import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';
const MYTHOS_IMAGE = 'https://cdn.magicpatterns.com/uploads/h58wUekQZycBGPqmB5effo/682effc0ba43af376950f23b_renders_robeta.jpg';
export function ModelsPage() {
  useSEO({
    title: 'Models — North American Lineup',
    description: 'Explore the Robeta camper van lineup for North America. Precision engineered in Slovenia, adapted for the open road with European luxury and craftsmanship.'
  });
  return <main className="bg-white min-h-screen pt-32 md:pt-40 pb-20" data-id="element-549">
      {/* 1. Page Header */}
      <section className="container mx-auto px-6 md:px-12 mb-20 md:mb-32" data-id="element-550">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl" data-id="element-551">
          <span className="text-robeta-copper text-xs font-bold uppercase tracking-wide-editorial block mb-6" data-id="element-552">
            Our Lineup
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-robeta-black uppercase tracking-editorial leading-tight mb-6" data-id="element-553">
            Our North American Lineup
          </h1>
          <p className="text-lg md:text-xl font-light text-robeta-black/60 max-w-2xl leading-relaxed" data-id="element-554">
            Discover Robeta camper vans designed for North American adventure.
            Precision engineered in Slovenia, adapted for the open road.
          </p>
        </motion.div>
      </section>

      {/* 2. Featured Model Showcase */}
      <section className="w-full mb-32" data-id="element-555">
        <div className="container mx-auto px-6 md:px-12" data-id="element-556">
          <Link to="/models/mythos4two" className="block group" data-id="element-557">
            <motion.div initial={{
            opacity: 0,
            scale: 0.98
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1
          }} className="relative w-full aspect-[4/5] md:aspect-[16/9] min-h-[60vh] overflow-hidden" data-id="element-558">
              <img src={MYTHOS_IMAGE} alt="Mythos 4 Two" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-559" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80" data-id="element-560" />

              <div className="absolute bottom-0 left-0 w-full p-8 md:p-16 lg:p-20" data-id="element-561">
                <motion.div initial={{
                opacity: 0,
                y: 30
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.8,
                delay: 0.2
              }} className="max-w-3xl" data-id="element-562">
                  <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase tracking-editorial leading-none mb-6" data-id="element-563">
                    Mythos
                    <br data-id="element-564" />4 Two
                  </h2>
                  <p className="text-lg md:text-xl text-white/80 font-light mb-10 max-w-xl leading-relaxed" data-id="element-565">
                    European craftsmanship meets North American adventure. A
                    Class B camper van designed without compromise for two.
                  </p>
                  <div className="flex flex-col sm:flex-row items-start gap-6" data-id="element-566">
                    <span className="inline-block bg-white text-robeta-black px-10 py-4 font-bold uppercase tracking-widest text-sm hover:bg-robeta-mist transition-colors" data-id="element-567">
                      Explore Mythos 4 Two
                    </span>
                    <span className="inline-flex items-center text-white/70 hover:text-white uppercase tracking-widest text-xs font-bold border-b border-white/30 hover:border-white pb-1 transition-all mt-4 sm:mt-0 sm:self-center" data-id="element-568">
                      Download Brochure
                      <ArrowRight className="ml-2 w-4 h-4" data-id="element-569" />
                    </span>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </Link>
        </div>
      </section>

      {/* 3. Future Models Placeholder */}
      <section className="py-32 bg-robeta-mist/10" data-id="element-570">
        <div className="container mx-auto px-6 md:px-12 text-center" data-id="element-571">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-572">
            <h3 className="text-2xl md:text-3xl font-light text-robeta-black/40 uppercase tracking-editorial mb-4" data-id="element-573">
              More Models Coming Soon
            </h3>
            <p className="text-sm md:text-base text-robeta-black/30 font-light max-w-md mx-auto" data-id="element-574">
              Additional Robeta models tailored for North America are arriving
              soon. Stay tuned for updates.
            </p>
          </motion.div>
        </div>
      </section>
    </main>;
}